// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type SingleLargeArchiveSearchScopeType from '../contract/SingleLargeArchiveSearchScopeType';

export default function singleLargeArchiveSearchScopeType(
    data: SingleLargeArchiveSearchScopeType
): SingleLargeArchiveSearchScopeType {
    const result: SingleLargeArchiveSearchScopeType = {
        __type: 'SingleLargeArchiveSearchScopeType:#Exchange',
        ...data,
    };

    return result;
}
